<script>
import Vue from 'vue';
import {mapState} from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState({
            terms: state => state.contract.contract.item.terms
        })
    }
});
</script>
<template>
    <div class="contract-form-terms">
        <div class="contract-form-terms__content">
            <div class="contract-form-terms__heading">
                <div class="contract-form-terms__header">
                    {{ $t('contract.form.terms.heading.header') }}
                </div>
            </div>
            <div class="contract-form-terms__body">
                <div class="contract-form-terms__terms-header">{{ terms.header }}</div>
                <div class="contract-form-terms__terms-text">{{ terms.text }}</div>
                <div class="contract-form-terms__items">
                    <div v-for="(article, index) in terms.articles" :key="`article_ ${index}`" class="contract-form-terms__item">
                        <div class="contract-form-terms__item-header">{{ article.header }}</div>
                        <div class="contract-form-terms__item-clauses">
                            <div v-for="(clause, index) in article.clauses" :key="`clause_${index}`" class="contract-form-terms__item-clause">
                                <div class="contract-form-terms__item-clause-header">{{ clause.header }}</div>
                                <template v-if="clause.clause.title">
                                    <div class="contract-form-terms__item-clause-text">{{ clause.clause.title }}</div>
                                    <div class="contract-form-terms__item-clause-points">
                                        <ul>
                                            <li v-for="(text, clauseIndex) in clause.clause.points" :key="`clauseArray_${clauseIndex}`">
                                                {{ text }}
                                            </li>
                                        </ul>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="contract-form-terms__item-clause-text">{{ clause.clause }}</div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormTerms/ContractFormTerms.vue